import { Injectable } from "@angular/core";
import { AppActionTypes } from "@app/store/actions/app.actions";
import {
  FetchMessagesUnreadCountFailure,
  FetchMessagesUnreadCountSuccess
} from "@app/store/actions/messages-unread-count.actions";
import { MainState } from "@app/store/state";
import { selectCurrentUser } from "@features/account/store/auth.selectors";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { MessagesApiService } from "@shared/services/messages-api.service";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

@Injectable()
export class MessagesUnreadCountEffects {
  fetchMessagesUnreadCount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActionTypes.FETCH_MESSAGES_UNREAD_COUNT),
      withLatestFrom(this.store$.select(selectCurrentUser)),
      switchMap(([, user]) => {
        // Only fetch if user is authenticated
        if (!user) {
          return of(new FetchMessagesUnreadCountSuccess({ count: 0 }));
        }
        return this.messagesApi.getUnreadCount().pipe(
          map(response => {
            // API returns {unreadCount: number}
            const count = typeof response === "number" ? response : response.unreadCount;
            return new FetchMessagesUnreadCountSuccess({ count });
          }),
          catchError(error => of(new FetchMessagesUnreadCountFailure({ error })))
        );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store<MainState>,
    private readonly messagesApi: MessagesApiService
  ) {}
}
